import { render, staticRenderFns } from "./teamForm.vue?vue&type=template&id=0c49a128&"
import script from "./teamForm.vue?vue&type=script&lang=ts&"
export * from "./teamForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports